const { formatDateTime } = require('gui');
const negotiateCustomsEventText = require('./negotiateCustomsEventText');

module.exports = function extractCustomsEvent(customs) {
    if(!customs)
        return [];

    const externalEvent = {
        time: formatDateTime(customs.Date, 'LT'),
        date: formatDateTime(customs.Date, 'L'),
        ticks: customs.Date,
        isActual: (customs.Date !== undefined)
    };
    externalEvent.place = negotiateCustomsEventText(customs.Result);

    return [externalEvent];
}
